export const StopTypesConstants = {
    PRICE_LIST: 'PRICE_LIST',
    FREE_TEXT: 'FREE_TEXT',
    BIDDING: 'BIDDING'
};
